module.exports = __webpack_public_path__ + "static/media/logo-turismo-portugal.38801ca7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-turismo-portugal.svg
// module id = 321
// module chunks = 0